import { NotificationResources } from '../constants/notification'

export const getRoverRoutes = ({
  resourceType,
  resourceTypeId,
}: IGetPlatformRoutes): string => {
  switch (resourceType) {
    case NotificationResources.ClientApplication:
      return `/app/rover/client-applications/list/${resourceTypeId}`
    case NotificationResources.PartnerProposal:
      return `/app/rover/partner-proposals/list/${resourceTypeId}`
    default:
      throw new Error('resource type not recognized for rover app')
  }
}
